import React from 'react';
import { StatusBar } from 'expo-status-bar';
import { StyleSheet, Text, View } from 'react-native';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import Navigation from 'navigation/Navigation';
import AppContext from 'contexts/AppContext';
import Loading from 'components/Loading';

export default function App() {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  return (
    <SafeAreaProvider>
      <AppContext.Provider value={{ isLoading, setIsLoading }}>
        <Navigation />
      </AppContext.Provider>
    </SafeAreaProvider>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
